// extracted by mini-css-extract-plugin
module.exports = {"karta":"Card_karta__p3KcG","cardButton":"Card_cardButton__2yXJt"};